import { require_react_is as e } from "./index26.js";
import * as t from "react";
//#region ../../node_modules/.pnpm/@mui+utils@7.3.9_@types+react@19.2.14_react@19.2.4/node_modules/@mui/utils/esm/deepmerge/deepmerge.js
var n = e();
function r(e) {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function i(e) {
	if (/* @__PURE__ */ t.isValidElement(e) || (0, n.isValidElementType)(e) || !r(e)) return e;
	let a = {};
	return Object.keys(e).forEach((t) => {
		a[t] = i(e[t]);
	}), a;
}
function a(e, o, s = { clone: !0 }) {
	let c = s.clone ? { ...e } : e;
	return r(e) && r(o) && Object.keys(o).forEach((l) => {
		/* @__PURE__ */ t.isValidElement(o[l]) || (0, n.isValidElementType)(o[l]) ? c[l] = o[l] : r(o[l]) && Object.prototype.hasOwnProperty.call(e, l) && r(e[l]) ? c[l] = a(e[l], o[l], s) : s.clone ? c[l] = r(o[l]) ? i(o[l]) : o[l] : c[l] = o[l];
	}), c;
}
//#endregion
export { a as default, r as isPlainObject };

//# sourceMappingURL=index27.js.map